import { snakeToCamelCase } from '@utils/textHelpers';
import {
  DisplayOption,
  DisplayOptionSetting,
  DisplayOptionSettingsAttribute,
  DisplayOptionSettingsGroup,
  DisplayOptionSettingsName,
  DisplayOptionSettingsSubGroup,
  DisplayOptionSettingsValue,
  DisplayOptionsSettings,
  DisplayOptionsSettingsEndpoint,
} from './types';

export const parseDisplayOptions = (arr?: DisplayOption[]): DisplayOption[] =>
  arr?.map((a) => ({
    ...a,
    endpoint: snakeToCamelCase(a.endpoint) as DisplayOptionsSettingsEndpoint,
    settings: Object.keys(a.settings).reduce((acc, key) => {
      // eslint-disable-next-line immutable/no-mutation
      acc[snakeToCamelCase(key) as DisplayOptionSettingsAttribute] =
        a.settings[key as DisplayOptionSettingsAttribute];
      return acc;
    }, {} as DisplayOptionSetting),
  })) || [];

export const parseDisplayOptionsSettingsValues = (
  arr?: DisplayOptionSettingsValue[],
): DisplayOptionSettingsValue[] =>
  arr?.map((a) => ({
    ...a,
    group: snakeToCamelCase(a.group) as DisplayOptionSettingsGroup,
    values: parseDisplayOptionsSettingsValues(a?.values),
    elements:
      a.elements?.map((b) => ({
        ...b,
        name: snakeToCamelCase(b.name) as DisplayOptionSettingsName,
        attributeName: snakeToCamelCase(b.attributeName) as DisplayOptionSettingsAttribute,
        group: snakeToCamelCase(b.group) as DisplayOptionSettingsGroup,
        subGroup: b?.subGroup
          ? (snakeToCamelCase(b.subGroup) as DisplayOptionSettingsSubGroup)
          : undefined,
      })) || [],
  })) || [];

export const parseDisplayOptionsSettings = (
  arr?: DisplayOptionsSettings[],
): DisplayOptionsSettings[] =>
  arr?.map((a) => ({
    ...a,
    endpoint: snakeToCamelCase(a.endpoint) as DisplayOptionsSettingsEndpoint,
    values: parseDisplayOptionsSettingsValues(a?.values),
  })) || [];
